import { render, staticRenderFns } from "./NameResolver.vue?vue&type=template&id=b34a7f72&"
import script from "./NameResolver.vue?vue&type=script&lang=js&"
export * from "./NameResolver.vue?vue&type=script&lang=js&"
import style0 from "./NameResolver.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports